module.exports = __webpack_public_path__ + "static/media/image1.7bc30bc6.jpg";